import { useState } from "react";
export default function NotifySms() {
  const [isModalOpenCreateTpl, setIsModalOpenCreateTpl] = useState(false);
  const [isPreviewOpenWhatsapp, setIsPreviewOpenWhatsapp] = useState(false);
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Notify via SMS
            </div>
            <div className="page-sub" id="page-sub">
              Notifications › SMS Broadcast
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          {/* STAT STRIP */}
          <div className="stat-grid" style={{ marginBottom: 16 }}>
            <div className="stat-card">
              <div className="stat-icon">📤</div>
              <div className="stat-label">Sent This Month</div>
              <div className="stat-value">1,284</div>
              <div className="stat-delta delta-up">This month</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Delivered</div>
              <div className="stat-value">1,261</div>
              <div className="stat-delta delta-up">Success rate</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">❌</div>
              <div className="stat-label">Failed</div>
              <div className="stat-value">23</div>
              <div className="stat-delta delta-dn">Errors</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-label">API Cost</div>
              <div className="stat-value">₹642</div>
              <div className="stat-delta delta-neu">This month</div>
            </div>
          </div>
          {/* MAIN PANEL */}
          <div
            className="cus-grid-054"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 340px",
              gap: 16,
              alignItems: "start",
            }}
          >
            {/* LEFT: SEND FORM */}
            <div className="card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 16,
                  paddingBottom: 12,
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <span style={{ fontSize: 18 }}>📱</span>
                <div style={{ fontSize: 14, fontWeight: 700 }}>
                  Send SMS Notification
                </div>
              </div>
              {/* API SELECTOR */}
              <div className="form-group mb12">
                <label>Send via API</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select id="api-sel-sms" style={{ flex: 1 }}>
                    <option value={1}>MSG91 Primary</option>
                    <option value={2} disabled="" style={{ color: "#ccc" }}>
                      Twilio SMS (inactive)
                    </option>
                  </select>
                  <span
                    id="api-status-sms"
                    style={{
                      fontSize: 10,
                      padding: "3px 8px",
                      borderRadius: 99,
                      background: "#EAF3DE",
                      color: "#27500A",
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                    }}
                  >
                    ✓ Active
                  </span>
                </div>
                <div className="input-hint" style={{ marginTop: 3 }}>
                  Only active APIs shown.{" "}
                  <span
                    onclick="showPage('sa-sys-smsapi',document.querySelector('[data-id=\'sa-sys-smsapi\']'))"
                    style={{
                      color: "var(--blue)",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Manage SMS APIs →
                  </span>
                </div>
              </div>
              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  marginBottom: 12,
                }}
              />
              <div className="form-group mb12">
                <label>Recipients</label>
                <select
                  id="recp-sel-sms"
                  onchange="toggleCustomInput('sms',this.value)"
                >
                  <option value="all">All Users (128)</option>
                  <option value="active">Active Subscribers (94)</option>
                  <option value="inactive">Inactive Users (12)</option>
                  <option value="expiring">Expiring in 7 Days (7)</option>
                  <option value="custom">Custom Selection</option>
                </select>
              </div>
              <div
                id="custom-box-sms"
                style={{ display: "none", marginBottom: 12 }}
              >
                <label
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    display: "block",
                    marginBottom: 5,
                  }}
                >
                  Mobile Numbers (each on a new line)
                </label>
                <div style={{ position: "relative" }}>
                  <textarea
                    id="custom-input-sms"
                    oninput="countLines('sms')"
                    style={{
                      minHeight: 100,
                      fontFamily: "monospace",
                      fontSize: 13,
                      lineHeight: "1.8",
                      border: "1.5px solid var(--border-mid)",
                      padding: "10px 12px",
                      paddingRight: 36,
                    }}
                    placeholder="919044004486
                           919876543210
                           918765432109"
                    defaultValue={""}
                  />
                  <div
                    onclick="countLines('sms')"
                    style={{
                      position: "absolute",
                      bottom: 8,
                      right: 8,
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      background: "#534AB7",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span style={{ color: "#fff", fontSize: 14 }}>↺</span>
                  </div>
                </div>
                <div
                  id="custom-count-sms"
                  style={{
                    fontSize: 12,
                    color: "#534AB7",
                    fontWeight: 600,
                    marginTop: 5,
                  }}
                >
                  0 numbers loaded
                </div>
              </div>
              <div className="form-group mb12">
                <label>Message *</label>
                <textarea
                  id="msg-body-sms"
                  style={{ minHeight: 110, lineHeight: "1.7" }}
                  placeholder="Type your message or click Use on a template →"
                  defaultValue={
                    "Dear {name}, your subscription expires on {date}. Renew now: {link}"
                  }
                />
              </div>
              <div
                style={{
                  background: "var(--blue-light)",
                  borderRadius: "var(--radius-md)",
                  padding: "8px 12px",
                  fontSize: 11,
                  color: "#0C447C",
                  marginBottom: 14,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 6,
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 600 }}>Placeholders:</span>
                <span
                  onclick="insertPlaceholder('sms','{name}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}name{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{amount}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}amount{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{date}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}date{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{link}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}link{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{plan}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}plan{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{month}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}month{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{fee}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}fee{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{room}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}room{"}"}
                </span>
                <span
                  onclick="insertPlaceholder('sms','{otp}')"
                  style={{
                    background: "#DBEAFE",
                    border: "0.5px solid #93C5FD",
                    borderRadius: 4,
                    padding: "1px 6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "monospace",
                  }}
                  title="Click to insert"
                >
                  {"{"}otp{"}"}
                </span>
              </div>
              <div className="form-group mb12">
                <label>Schedule</label>
                <select
                  id="sched-type-sms"
                  onchange="toggleSchedTime('sms',this.value)"
                >
                  <option value="now">Send Immediately</option>
                  <option value="later">Schedule for Later</option>
                </select>
              </div>
              <div
                id="sched-fields-sms"
                style={{ display: "none", marginBottom: 14 }}
              >
                <div className="form-grid">
                  <div className="form-group">
                    <label>Date</label>
                    <input type="date" id="sched-date-sms" />
                  </div>
                  <div className="form-group">
                    <label>Time</label>
                    <input type="time" id="sched-time-sms" />
                  </div>
                </div>
                <div className="input-hint" style={{ marginTop: 4 }}>
                  Message will be queued and sent at the scheduled date &amp;
                  time
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  className="btn btn-primary"
                  style={{ background: "#534AB7", borderColor: "#534AB7" }}
                >
                  📱 Send Now
                </button>
                <button className="btn">Save Draft</button>
                <button
                  className="btn"
                  onClick={() => setIsPreviewOpenWhatsapp(true)}
                >
                  👁 Preview
                </button>
              </div>
            </div>
            {/* RIGHT: TEMPLATES PANEL */}
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 12,
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "var(--text-primary)",
                    }}
                  >
                    Message Templates
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      marginTop: 2,
                    }}
                  >
                    Click <strong>Use</strong> to auto-fill ·{" "}
                    <strong>Edit</strong> to modify
                  </div>
                </div>
                <button
                  onClick={() => setIsModalOpenCreateTpl(true)}
                  className="btn btn-sm btn-primary"
                  style={{ background: "#534AB7", borderColor: "#534AB7" }}
                >
                  + Create
                </button>
              </div>
              <div
                id="tpl-list-sms"
                style={{
                  maxHeight: "calc(100vh - 320px)",
                  overflowY: "auto",
                  paddingRight: 2,
                }}
              >
                <div
                  className="tpl-card"
                  id="tpl-sms-1"
                  style={{
                    background: "var(--bg-primary)",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "var(--radius-md)",
                    padding: 12,
                    cursor: "pointer",
                    transition: "all .15s",
                    marginBottom: 8,
                  }}
                  onmouseenter="this.style.borderColor='#534AB7';this.style.boxShadow='0 0 0 2px #534AB722'"
                  onmouseleave="this.style.borderColor='var(--border-light)';this.style.boxShadow='none'"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "var(--text-primary)",
                          marginBottom: 3,
                        }}
                      >
                        Rent Due Reminder
                      </div>
                      <div
                        style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                      >
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          rent
                        </span>{" "}
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          reminder
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      <button
                        onclick="openEditTemplate('sms',1)"
                        style={{
                          padding: "4px 8px",
                          background: "var(--bg-secondary)",
                          color: "var(--text-secondary)",
                          border: "0.5px solid var(--border-mid)",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                        title="Edit template"
                      >
                        ✎
                      </button>
                      <button
                        onclick="useTemplate('sms',1)"
                        style={{
                          padding: "4px 12px",
                          background: "#534AB7",
                          color: "#fff",
                          border: "none",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Use ↗
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxHeight: 64,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    Hi{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}name{"}"}
                    </span>
                    , your rent of ₹
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}amount{"}"}
                    </span>{" "}
                    is due on{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}date{"}"}
                    </span>
                    . Please pay on time to avoid late fees. Pay now:{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}link{"}"}
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background:
                          "linear-gradient(transparent,var(--bg-primary))",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="tpl-card"
                  id="tpl-sms-2"
                  style={{
                    background: "var(--bg-primary)",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "var(--radius-md)",
                    padding: 12,
                    cursor: "pointer",
                    transition: "all .15s",
                    marginBottom: 8,
                  }}
                  onmouseenter="this.style.borderColor='#534AB7';this.style.boxShadow='0 0 0 2px #534AB722'"
                  onmouseleave="this.style.borderColor='var(--border-light)';this.style.boxShadow='none'"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "var(--text-primary)",
                          marginBottom: 3,
                        }}
                      >
                        Payment Confirmation
                      </div>
                      <div
                        style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                      >
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          payment
                        </span>{" "}
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          confirmation
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      <button
                        onclick="openEditTemplate('sms',2)"
                        style={{
                          padding: "4px 8px",
                          background: "var(--bg-secondary)",
                          color: "var(--text-secondary)",
                          border: "0.5px solid var(--border-mid)",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                        title="Edit template"
                      >
                        ✎
                      </button>
                      <button
                        onclick="useTemplate('sms',2)"
                        style={{
                          padding: "4px 12px",
                          background: "#534AB7",
                          color: "#fff",
                          border: "none",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Use ↗
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxHeight: 64,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    Dear{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}name{"}"}
                    </span>
                    , ₹
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}amount{"}"}
                    </span>{" "}
                    received successfully for{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}month{"}"}
                    </span>
                    . Thank you! Download receipt:{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}link{"}"}
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background:
                          "linear-gradient(transparent,var(--bg-primary))",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="tpl-card"
                  id="tpl-sms-3"
                  style={{
                    background: "var(--bg-primary)",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "var(--radius-md)",
                    padding: 12,
                    cursor: "pointer",
                    transition: "all .15s",
                    marginBottom: 8,
                  }}
                  onmouseenter="this.style.borderColor='#534AB7';this.style.boxShadow='0 0 0 2px #534AB722'"
                  onmouseleave="this.style.borderColor='var(--border-light)';this.style.boxShadow='none'"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "var(--text-primary)",
                          marginBottom: 3,
                        }}
                      >
                        Late Fee Alert
                      </div>
                      <div
                        style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                      >
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          late fee
                        </span>{" "}
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          alert
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      <button
                        onclick="openEditTemplate('sms',3)"
                        style={{
                          padding: "4px 8px",
                          background: "var(--bg-secondary)",
                          color: "var(--text-secondary)",
                          border: "0.5px solid var(--border-mid)",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                        title="Edit template"
                      >
                        ✎
                      </button>
                      <button
                        onclick="useTemplate('sms',3)"
                        style={{
                          padding: "4px 12px",
                          background: "#534AB7",
                          color: "#fff",
                          border: "none",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Use ↗
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxHeight: 64,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    Hi{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}name{"}"}
                    </span>
                    , a late fee of ₹
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}fee{"}"}
                    </span>{" "}
                    has been added to your account. Total due: ₹
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}amount{"}"}
                    </span>
                    . Pay now:{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}link{"}"}
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background:
                          "linear-gradient(transparent,var(--bg-primary))",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="tpl-card"
                  id="tpl-sms-4"
                  style={{
                    background: "var(--bg-primary)",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "var(--radius-md)",
                    padding: 12,
                    cursor: "pointer",
                    transition: "all .15s",
                    marginBottom: 8,
                  }}
                  onmouseenter="this.style.borderColor='#534AB7';this.style.boxShadow='0 0 0 2px #534AB722'"
                  onmouseleave="this.style.borderColor='var(--border-light)';this.style.boxShadow='none'"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "var(--text-primary)",
                          marginBottom: 3,
                        }}
                      >
                        KYC Pending
                      </div>
                      <div
                        style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                      >
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          kyc
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      <button
                        onclick="openEditTemplate('sms',4)"
                        style={{
                          padding: "4px 8px",
                          background: "var(--bg-secondary)",
                          color: "var(--text-secondary)",
                          border: "0.5px solid var(--border-mid)",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                        title="Edit template"
                      >
                        ✎
                      </button>
                      <button
                        onclick="useTemplate('sms',4)"
                        style={{
                          padding: "4px 12px",
                          background: "#534AB7",
                          color: "#fff",
                          border: "none",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Use ↗
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxHeight: 64,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    Dear{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}name{"}"}
                    </span>
                    , your KYC verification is pending. Please upload your
                    documents to avoid service disruption:{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}link{"}"}
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background:
                          "linear-gradient(transparent,var(--bg-primary))",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="tpl-card"
                  id="tpl-sms-5"
                  style={{
                    background: "var(--bg-primary)",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "var(--radius-md)",
                    padding: 12,
                    cursor: "pointer",
                    transition: "all .15s",
                    marginBottom: 8,
                  }}
                  onmouseenter="this.style.borderColor='#534AB7';this.style.boxShadow='0 0 0 2px #534AB722'"
                  onmouseleave="this.style.borderColor='var(--border-light)';this.style.boxShadow='none'"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "var(--text-primary)",
                          marginBottom: 3,
                        }}
                      >
                        Subscription Expiry
                      </div>
                      <div
                        style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                      >
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          subscription
                        </span>{" "}
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          expiry
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      <button
                        onclick="openEditTemplate('sms',5)"
                        style={{
                          padding: "4px 8px",
                          background: "var(--bg-secondary)",
                          color: "var(--text-secondary)",
                          border: "0.5px solid var(--border-mid)",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                        title="Edit template"
                      >
                        ✎
                      </button>
                      <button
                        onclick="useTemplate('sms',5)"
                        style={{
                          padding: "4px 12px",
                          background: "#534AB7",
                          color: "#fff",
                          border: "none",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Use ↗
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxHeight: 64,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    Hi{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}name{"}"}
                    </span>
                    , your{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}plan{"}"}
                    </span>{" "}
                    plan expires on{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}date{"}"}
                    </span>
                    . Renew now to continue uninterrupted access:{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}link{"}"}
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background:
                          "linear-gradient(transparent,var(--bg-primary))",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="tpl-card"
                  id="tpl-sms-6"
                  style={{
                    background: "var(--bg-primary)",
                    border: "0.5px solid var(--border-light)",
                    borderRadius: "var(--radius-md)",
                    padding: 12,
                    cursor: "pointer",
                    transition: "all .15s",
                    marginBottom: 8,
                  }}
                  onmouseenter="this.style.borderColor='#534AB7';this.style.boxShadow='0 0 0 2px #534AB722'"
                  onmouseleave="this.style.borderColor='var(--border-light)';this.style.boxShadow='none'"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 8,
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "var(--text-primary)",
                          marginBottom: 3,
                        }}
                      >
                        OTP Verification
                      </div>
                      <div
                        style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                      >
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          otp
                        </span>{" "}
                        <span
                          style={{
                            background: "var(--bg-secondary)",
                            border: "0.5px solid var(--border-light)",
                            borderRadius: 99,
                            padding: "1px 7px",
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                          }}
                        >
                          security
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                      <button
                        onclick="openEditTemplate('sms',6)"
                        style={{
                          padding: "4px 8px",
                          background: "var(--bg-secondary)",
                          color: "var(--text-secondary)",
                          border: "0.5px solid var(--border-mid)",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                        }}
                        title="Edit template"
                      >
                        ✎
                      </button>
                      <button
                        onclick="useTemplate('sms',6)"
                        style={{
                          padding: "4px 12px",
                          background: "#534AB7",
                          color: "#fff",
                          border: "none",
                          borderRadius: 5,
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          fontFamily: "inherit",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Use ↗
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxHeight: 64,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    Your NestManager OTP is{" "}
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: 3,
                        padding: "0 3px",
                        fontWeight: 600,
                      }}
                    >
                      {"{"}otp{"}"}
                    </span>
                    . Valid for 10 minutes. Do not share with anyone.
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background:
                          "linear-gradient(transparent,var(--bg-primary))",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* PREVIEW MODAL (inline, toggled) */}
          {isPreviewOpenWhatsapp && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.5)",
                zIndex: 998,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "var(--radius-lg)",
                  width: 520,
                  maxWidth: "95vw",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
                }}
              >
                <div
                  style={{
                    padding: "16px 20px",
                    borderBottom: "0.5px solid var(--border-light)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    Message Preview
                  </div>
                  <button
                    onClick={() => setIsPreviewOpenWhatsapp(false)}
                    style={{
                      border: "none",
                      background: "none",
                      fontSize: 20,
                      cursor: "pointer",
                      color: "var(--text-secondary)",
                    }}
                  >
                    ✕
                  </button>
                </div>
                <div
                  id="preview-content-whatsapp"
                  style={{
                    padding: 20,
                    fontSize: 13,
                    lineHeight: "1.8",
                    whiteSpace: "pre-wrap",
                    color: "var(--text-primary)",
                  }}
                />
                <div
                  id="preview-content-email"
                  style={{
                    padding: "5px",
                    whiteSpace: "pre-wrap",
                    color: "var(--text-primary)",
                  }}
                >
                  Dear
                  <strong style={{ color: "#0F6E56" }}>Priya Sharma</strong>,
                  your subscription expires on{" "}
                  <strong style={{ color: "#0F6E56" }}>May 5, 2025</strong>.
                  Renew now:{" "}
                  <strong style={{ color: "#0F6E56" }}>
                    https://pay.nestmgr.in/rm/204
                  </strong>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Add new sms template */}
      {isModalOpenCreateTpl && (
        <div className="modal-overlay open" id="modal-create-tpl">
          <div className="modal" style={{ width: 580 }}>
            <div className="modal-header">
              <div className="modal-title" id="ctpl-modal-title">
                Create SMS Template
              </div>
              <button
                className="modal-close"
                onClick={() => setIsModalOpenCreateTpl(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <input type="hidden" id="ctpl-type" defaultValue="whatsapp" />
              <input type="hidden" id="ctpl-edit-id" defaultValue="" />
              <div className="info-box">
                Use placeholders like <strong>{"{name}"}</strong>,{" "}
                <strong>{"{amount}"}</strong>, <strong>{"{date}"}</strong>,{" "}
                <strong>{"{link}"}</strong>, <strong>{"{plan}"}</strong>,{" "}
                <strong>{"{fee}"}</strong>, <strong>{"{room}"}</strong>,{" "}
                <strong>{"{otp}"}</strong> in your template.
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Template Name *</label>
                  <input
                    type="text"
                    id="ctpl-name"
                    placeholder="e.g. Rent Due Reminder"
                  />
                </div>
                <div className="form-group">
                  <label>Tags (comma separated)</label>
                  <input
                    type="text"
                    id="ctpl-tags"
                    placeholder="rent, reminder, alert"
                  />
                </div>
              </div>
              <div
                className="form-group mb12 mt12"
                id="ctpl-subject-row"
                style={{ display: "none", marginTop: 12 }}
              >
                <label>Email Subject *</label>
                <input
                  type="text"
                  id="ctpl-subject"
                  placeholder="e.g. Your rent is due — Action Required"
                />
              </div>
              <div className="form-group mb12" style={{ marginTop: 12 }}>
                <label>Message Body *</label>
                <textarea
                  id="ctpl-body"
                  style={{ minHeight: 140, lineHeight: "1.7" }}
                  placeholder="Hi {name}, your rent of ₹{amount} is due on {date}. Pay now: {link}"
                  defaultValue={""}
                />
              </div>
              <div
                style={{
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 12px",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    marginBottom: 6,
                  }}
                >
                  Click to insert placeholder at cursor:
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {[
                    "{name}",
                    "{amount}",
                    "{date}",
                    "{link}",
                    "{plan}",
                    "{month}",
                    "{fee}",
                    "{room}",
                    "{otp}",
                  ].map((p) => (
                    <span
                      key={p}
                      // onClick={() => insertPlaceholderTpl(p)}
                      style={{
                        background: "var(--blue-light)",
                        border: "0.5px solid #93C5FD",
                        borderRadius: 4,
                        padding: "2px 8px",
                        cursor: "pointer",
                        fontWeight: 700,
                        fontFamily: "monospace",
                        fontSize: 12,
                        color: "#1e40af",
                      }}
                    >
                      {p}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn"
                onClick={() => setIsModalOpenCreateTpl(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                id="ctpl-save-btn"
                // onClick={saveNewTemplate}
              >
                Save Template
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
